import { isEmpty } from 'lodash'
import { createContext, FC, ReactNode, useContext } from 'react'

import { useProfileQuery } from '@/features/auth/queries/useProfileQuery'
import { IProfile } from '@/features/auth/types'

export interface IAuthContextState {
  isSigned: boolean
  profile: IProfile | null
}

const AuthContext = createContext<IAuthContextState>({
  isSigned: false,
  profile: null,
})

export interface IAuthProviderProps {
  children: ReactNode
}

const AuthProvider: FC<IAuthProviderProps> = ({ children }) => {
  const { data: profile } = useProfileQuery()

  return (
    <AuthContext.Provider
      value={{
        isSigned: !isEmpty(profile),
        profile: profile ?? null,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
export const useAuth = () => useContext(AuthContext)
